import React from 'react';
import jss from 'jss';

import { CheckIcon } from 'icons';
import theme from 'utils/theme';

const styles = ({ margin }) => ({
    checkboxWrapper: {
        alignItems: 'center',
        display: 'flex',
        flexFlow: 'row',
        margin: margin || '33px 0 33px -19px',

        '& input[type=checkbox]': {
            appearance: 'none',
            background: `${theme.colors.white}`,
            border: `1px solid ${theme.colors.black}`,
            borderRadius: '0',
            height: '16px',
            outline: 'none',
            marginRight: '8px',
            position: 'relative',
            transition: 'all 0.1s ease',
            width: '16px',
        },
        '& input[type=checkbox]:checked': {
            background: `${theme.colors.black}`,
            borderColor: `${theme.colors.black}`,
        },

        '& label': {
            fontSize: '13px',
            lineHeight: '145%',
        },

        '& a': {
            textDecoration: 'underline',
        },
    },
    icon: {
        padding: '5px',
        position: 'relative',
        right: '-18px',
        zIndex: '1',
    },
});

class Checkbox extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            checked: props.checked || false,
            value: props.value || undefined,
            label: props.label || '',
        };
        this.id = Math.random().toString(36).substr(2, 5);
    }

    componentWillReceiveProps(props) {
        const state = {
            checked: props.checked || false,
            value: props.value || undefined,
            label: props.label || '',
        };

        this.setState(state);
    }

    onChangeCallback = (e) => {
        const checked = e.target.checked;
        this.setState({ checked, hasError: false, error: '' });
        if (this.props.onChange) {
            this.props.onChange(checked);
        }
    };

    render() {
        const { name, type, customStyles } = this.props;
        const { label, checked, value } = this.state;
        const { classes } = jss.createStyleSheet(styles({ ...customStyles })).attach();

        return (
            <div data-test="accept-terms-checkbox" className={classes.checkboxWrapper}>
                <CheckIcon
                    size={9}
                    className={classes.icon}
                    onClick={() => {
                        document.getElementById(this.id).click();
                    }}
                />

                <input
                    data-test="checkbox-terms"
                    id={this.id}
                    name={name}
                    type={type || 'checkbox'}
                    value={value}
                    onChange={(e) => this.onChangeCallback(e)}
                    checked={checked}
                />
                {label && <label htmlFor={this.id}>{label}</label>}
            </div>
        );
    }
}

export default Checkbox;
